import React, { useEffect, useState } from "react";
import * as Yup from "yup";
import styled from "@emotion/styled";
import { useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { yupResolver } from "@hookform/resolvers/yup";
import { Grid, MenuItem } from "@mui/material";
import { useForm, FormProvider } from "react-hook-form";
import SearchableAutoComplete from "../../../../components/SearchableAutoComplete";
import FilterReset from "../../../../components/FilterReset";
import {
  invoiceStatusOptions,
  convertedValue,
  trafficReportDateRange,
} from "../../../../utils/common";
import ReactHookFormSelect from "../../../../components/ReactHookFormSelect";
import CustomTextField from "../../../../components/CustomTextField";
import { useDialog } from "../../../../contexts/DialogContext";
import CustomDatePicker from "../../../../components/CustomDatePicker";
import useTenant from "../../../../hooks/useTenant";

function AdvanceFilter(props) {
  const { unSetDialog } = useDialog();
  const initialRange = trafficReportDateRange("daily", [new Date(), new Date()]);

  const initialValues = {
    userName: "",
    reportType: "daily",
    transDateStr: initialRange.value,
    transDate: initialRange.dates,
  };

  const { fields, payload, setPayload, setFilterResetFunc, filterFormData, setFilterFormData } =
    props;

  const { t } = useTranslation();
  const methods = useForm({
    defaultValues: filterFormData || initialValues,
  });

  const {
    reset,
    handleSubmit,
    formState: { errors },
    control,
    watch,
    setValue,
  } = methods;

  useEffect(() => {
    setFilterResetFunc(() => () => reset(initialValues));
  }, [reset]);

  const onSubmit = async (data) => {
    try {
      const range = trafficReportDateRange(data.reportType, data.transDate);
      const formData = {
        ...data,
        transDate: range.dates,
        transDateStr: range.value,
      };
      setFilterFormData(formData);
      let filters = [];

      if (data.userName != null && Object.keys(data.userName).length != 0) {
        filters.push({
          fieldName: "userName",
          fieldValue: data.userName,
          op: "like",
          dataType: "string",
          condition: "and",
          isJoin: true,
          entityName: "RadUserEntity",
          attributeName: "radUser",
        });
      }

      if (formData.transDate != "" && formData.transDate != null) {
        filters.push({
          fieldName: "createdAt",
          fieldValue: formData.transDateStr,
          op: "btn",
          dataType: "string",
          condition: "and",
          isJoin: false,
        });
      }
      if (data.reportType != "" && data.reportType != null) {
        filters.push({
          fieldName: "reportType",
          fieldValue: data.reportType,
          op: "eq",
          dataType: "string",
          condition: "and",
          isJoin: false,
        });
      }
      setPayload({
        ...payload,
        filters: filters,
      });
      unSetDialog("advance_filter");
    } catch (err) {
      console.error(err, "errerrerrerr");
    }
  };

  return (
    <React.Fragment>
      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Grid container spacing={2} pt={8}>
            <Grid item md={6} sm={6} xs={8}>
              <ReactHookFormSelect
                name="reportType"
                label="Report Type"
                control={control}
                fullWidth
                variant="outlined"
                fields={fields}
                errors={errors}
              >
                <MenuItem key={"daily"} value={"daily"}>
                  Daily
                </MenuItem>
                <MenuItem key={"monthly"} value={"monthly"}>
                  Monthly
                </MenuItem>
              </ReactHookFormSelect>
            </Grid>
            <Grid item md={6} sm={6} xs={8}>
              <CustomTextField
                label={t("user_name")}
                name="userName"
                control={control}
                fullWidth
                variant="outlined"
                errors={errors}
              />
            </Grid>
          </Grid>
          <Grid container spacing={2} pt={8}>
            <Grid item md={6} sm={6} xs={8}>
              <CustomDatePicker
                name="transDate"
                nameTemp="transDateStr"
                label="Transaction Date"
                range={true}
                control={control}
              />
            </Grid>
          </Grid>

          <FilterReset resetForm={() => reset(initialValues)} />
        </form>
      </FormProvider>
    </React.Fragment>
  );
}

export default AdvanceFilter;
